import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Groups = () => {
  return (
    <div>
      <Container className="members_container">
        <h2>Our Members</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eum magni
          nostrum, deserunt rerum ab officiis, deleniti tempore, doloribus earum
          officia ullam? Velit quo dolo consec tetur adipis icing rem nam aut,
          neque error minus ullam?
        </p>
        <Row>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <img
              src="Images/testimonial-1.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-1.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-1.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-1.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-1.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-1.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
          <Col md={2}>
            <img
              src="Images/testimonial-3.jpg"
              alt=""
              className="img-fluid mb-4"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Groups;
